import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getUserData, getUserDetails } from '../../../../utils';
import { getProfileDataAsync } from '../../../store/slices/common/userProfileSlice';
import { Skeleton } from '../../Common/Skeleton';
import FlyoutMenu from '../FlyoutMenu/FlyoutMenu';
import ChatMenu from './ChatMenu';
import NotificationMenu from './NotificationMenu';

export default function LoggedInUserPanel() {
 
  const dispatch = useDispatch();
  const userDetails = getUserDetails();
  const userData = getUserData();

  useEffect(() => {
    if (userDetails === null) {
      dispatch(getProfileDataAsync({ profileId: userData?.profile_id }));
    }
  }, [userDetails]);

  return (
    <div className='hidden items-center gap-8 md:flex'>
      <ChatMenu />
      <NotificationMenu />

      {userDetails?.user_id ? (
        <FlyoutMenu userDetails={userDetails} />
      ) : (
        <Skeleton className='h-[30px] w-[120px] rounded-[16px] border border-[#E7E7E7]' />
      )}
    </div>
  );
}
